
  <div class="offer-contact">
    <div v-if="sending">
      <p>Отправка сообщения ...</p>
    </div>
    <div v-else>
      <div v-if="done">
        <p style="color:green;">Сообщение отправлено</p>
      </div>
      <div v-else>
        <input type="text" placeholder="Имя" v-model="name"/>
<!--        <input type="text" placeholder="Телефон" v-model="phone" />-->
        <the-mask :mask="'(###) ###-##-##'" placeholder="Телефон" v-model="phone" />
<!--        <input type="email" placeholder="Email" v-model="pochta"/>-->
        <textarea placeholder="Сообщение" rows="5" v-model="comment"></textarea>
        <label class="pd-agree">
          <input type="checkbox" v-model="agree"/>
          <span>Даю <a href="/privacy#consent" target="_blank">согласие на обработку персональных данных</a> и принимаю <a href="/privacy" target="_blank">Политику</a></span>
        </label>
        <div class="text-center">
          <span class="btn" @click="sendMessage" :class="agree ? '' : 'disabled'">Отправить</span>
        </div>
      </div>

    </div>


  </div>
